import React from 'react'
import { SiteHeader as Component } from '@swp/components'

export default function SiteHeader(props) {
return (
  <Component className="pos--fix --spacing5 --size-L" type={"SiteHeader"} item={{"color":"rgba(255,255,255,1)","colorHover":"rgba(255,255,255,0.5)","className":"fs--20"}} fixed={true} title={{"color":"rgba(255,255,255,1)","content":"Dárkové poukazy","className":"fs--26 ls--002"}} social={{"twitter":"saywebpage","facebook":"saywebpage","instagram":"saywebpage"}} backgroundColor={"rgba(3,3,26,1)"} button={{"className":"btn-box"}} />
)
}